module.exports = __webpack_public_path__ + "static/media/johnny-9.jpeg";